<app-page [dynamicHeight]="true" class="page-wrapper">
  <app-header>
    <h1 app-overline>Create simulation</h1>
    <h2 app-title>Select Hardware Configurations</h2>

    <app-header-actions style="display: flex; align-items: center">
      <button
        style="margin-right: 1em"
        mat-raised-button
        pally-rounded-button-m
        color="primary"
        (click)="createHwConfig()"
        *appIfCommandAvailable="'create_hardware'"
      >
        <mat-icon>add</mat-icon>Create
      </button>
    </app-header-actions>
  </app-header>

  <ng-container *ngIf="hwTableData$ | async as data">
    <!-- Loading state -->
    <app-loading *ngIf="data.isLoading"></app-loading>

    <!-- Error state -->
    <app-error *ngIf="data.error as error" [error]="error"></app-error>

    <app-table
      #table
      *ngIf="data.didSucceed"
      [inputData]="data.value"
      [clickableRows]="true"
      [clickToSelect]="true"
      [topRow]="false"
      [displayedColumns]="columnsToDisplay"
      [actions]="true"
      [preSelectedRows]="
        simWizardDataService.zimWizard.getSelected('hardwares')
      "
      [noDataText]="noDataHint"
      (actionClicked)="actionClicked($event)"
      (blockSelectedChange)="
        simWizardDataService.zimWizard.editHardwares($event)
      "
    ></app-table>
  </ng-container>
</app-page>
